import HttpService from './http.service';

const getContactInfo = async sessionData => {
  var contactInfo;
  var contactUsID = '';
  if (sessionData.countryId == '687PDC') {
    contactUsID = sessionData.manufacturingDivision;
  } else {
    contactUsID = sessionData.countryId;
  }

  var language = sessionData.language?.toLowerCase() || 'en';
  await HttpService.getAll(`/contact/${contactUsID}/${language}`)
    .then(res => {
      if (res.data) {
        contactInfo = res.data;
      }
    })
    .catch(error => {
      console.log(error);
    });
  return contactInfo;
};

export { getContactInfo };
